// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import styled from 'styled-components';
import DropdownArrow from '../../../assets/images/dropdown-arrow.svg';

export const S = {
  Container: styled.div`
    width: 200px;
    padding: 0 15px;
    height: 50px;

    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid #848484;
    border-radius: 2px;
    cursor: pointer;
  `,
  Current: styled.div`
    font: 16px Noto Sans TC;
    color: #A6A6A6;
  `,
  DropdownArrow: styled.img.attrs({ src: DropdownArrow, alt: 'dropdown-arrow' }) <{ isOpened: boolean }>`
    width: 14px;
    height: 10px;
    transition: all .5s;
    margin-left: auto;
    transform: rotate(${props => props.isOpened ? '0deg' : '180deg'});
  `,
  DropContainer: styled.div`
    width: 100%;
    position: absolute;
    top: 50px;
    left: 0px;
    background: #FFF;
    border-radius: 4px;
    box-shadow: 0px 2px 4px 0px #00000040;
  `,
  DropRow: styled.div`
    height: 50px;
    padding: 0 15px;
    display: flex;
    align-items: center;

    &:hover {
      background: rgba(201,201,201,0.3);
    }
  `,
  OptionTitle: styled.div`
    font: 16px Noto Sans TC;
    color: #666666;

    margin-left: 16px;
  `,
};
